<template>
  <!--
    主动气泡公共外壳：头部（头像/名字/AI/折叠）+ 正文插槽 + 三角
    样式由 tipCssVars（--agent-tip-*）驱动，按游戏 theme.entryTipStyle 注入
  -->
  <div class="agent-tip" :style="tipCssVars">
    <header class="agent-tip__header">
      <img
        v-if="tipAssistantImage"
        class="agent-tip__avatar"
        :src="tipAssistantImage"
        alt=""
      />
      <span class="agent-tip__name">{{ assistantName }}</span>
      <span class="agent-tip__ai-badge" aria-hidden="true">AI</span>
      <button
        v-if="tipMinimizeBtnImage"
        type="button"
        class="agent-tip__minimize"
        aria-label="close"
        @click.stop="$emit('close')"
      >
        <img :src="tipMinimizeBtnImage" alt="" />
      </button>
    </header>

    <div class="agent-tip__body">
      <p class="agent-tip__text">
        <slot name="message" />
      </p>
      <div class="agent-tip__actions">
        <slot name="actions" />
      </div>
    </div>

    <!-- 必须用此 class，TipContainer / floating-ui 才能定位箭头 -->
    <!-- <div class="agent-entry-tip__arrow" aria-hidden="true" /> -->
  </div>
</template>

<script>
import agentTipStyleMixin from '@mixins/officialTopupNew/agentTipStyleMixin';

export default {
  name: 'AgentTipFrame',
  mixins: [agentTipStyleMixin]
};
</script>

<style scoped>
.agent-tip {
  position: relative;
  box-sizing: border-box;
  width: fit-content;
  min-width: 200px;
  max-width: 250px;
  max-width: min(250px, calc(100vw - 24px));
  border-radius: var(--agent-tip-radius, 15px);
  border: var(--agent-tip-border, 1px solid #b9aaaf);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  background: var(--agent-tip-header-bg, #fff);
}

.agent-tip__header {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 12px;
  background: var(--agent-tip-header-bg, #4c3d38);
  border-radius: var(--agent-tip-radius, 15px) var(--agent-tip-radius, 15px) 0 0;
  box-sizing: border-box;
}

.agent-tip__avatar {
  flex-shrink: 0;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.12);
}

.agent-tip__name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 21px;
  font-weight: 600;
  color: var(--agent-tip-name, #edceaa);
  line-height: 1.2;
  white-space: nowrap;
}

.agent-tip__ai-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 16px;
  padding: 0 5px;
  border-radius: 8px 8px 8px 2px;
  background: var(--agent-tip-ai-badge-bg, #d08835);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 14px;
}

.agent-tip__minimize {
  margin-left: auto;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  margin-bottom: 22px;
}

.agent-tip__minimize img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.agent-tip__body {
  padding: 16px 14px 14px;
  background: var(--agent-tip-body-bg, #fff);
  border-radius: var(--agent-tip-radius, 15px);
  box-sizing: border-box;
}

.agent-tip__text {
  margin: 0 0 14px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: var(--agent-tip-text, #333);
  line-height: 1.4;
}

.agent-tip__text >>> em,
.agent-tip__text /deep/ em {
  font-style: normal;
  color: var(--agent-tip-highlight, #edceaa);
  font-weight: 700;
}

.agent-tip__actions {
  display: grid;
  grid-template-columns: minmax(min-content, 100%);
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  justify-items: stretch;
  gap: 10px;
}

.agent-tip__actions >>> .btn-quiet,
.agent-tip__actions >>> .btn-gotit {
  box-sizing: border-box;
  width: 100%;
  min-width: 97px;
  max-width: 100%;
  height: 32px;
  border-radius: 999px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 600;
  line-height: 32px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-tip__actions >>> .btn-quiet {
  border: none;
  background: var(--agent-tip-quiet-btn-bg, #8e8e8e);
  color: var(--agent-tip-quiet-btn-color, #fff);
}

.agent-tip__actions >>> .btn-gotit {
  border: none;
  background: var(--agent-tip-gotit-btn-bg, #d08835);
  color: var(--agent-tip-gotit-btn-color, #fff);
}

.agent-tip__arrow {
  position: absolute;
  left: 50%;
  bottom: -6px;
  width: 12px;
  height: 12px;
  background: var(--agent-tip-body-bg, #fff);
  border-right: var(--agent-tip-border, 1px solid #e8e8e8);
  border-bottom: var(--agent-tip-border, 1px solid #e8e8e8);
  transform: translateX(-50%) rotate(45deg);
}
</style>
